import { render } from "./market-chart.vue?vue&type=template&id=8e9d06b6"
import script from "./market-chart.vue?vue&type=script&lang=js"
export * from "./market-chart.vue?vue&type=script&lang=js"

import exportComponent from "/home/local/SERVER0/dsharma/Downloads/mobilecharts/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__